import {sessionService} from 'redux-react-session';

export const createUser = async (user) => {
    user.time = new Date();
    sessionService.saveUser(user);
};

export const getUser = async (history) => {
    await sessionService.loadUser().then((data) => {
        let date = new Date();
        if (!(data.time > date.setHours(date.getHours() - 3))) {
            deleteUser();
            if (history) {
                history.go();
            }
        }
    });
    return sessionService.loadUser();
};

export const deleteUser = async () => {
    sessionService.deleteUser();
};